import { Img, Text } from "./..";
import React from "react";

export default function AddPageProviderRow1({
  value,
  label,
  img,
  car
}) {
  return (
    <div className="flex items-center  gap-[18px]  p-2 rounded-md">
      
      <div className="flex items-center gap-[8px]">   
           <Img src={img} alt="יצרן" className="h-[18px]" />

           <Text
  size="h4_assistant16px_r"
  as="p"
  className="text-[16px] font-normal !text-black-900_03"
>
          {label}
        </Text>
      </div>
      <Text size="textxl" as="p" className="ml-4 pl-2 border-r pr-2 border-gray-300 text-[16px] font-normal !text-black-900_03">
      {value}
      </Text>
    </div>
  );
}
